import * as React from 'react';
import { pure } from 'recompose';

/* UI */
import TextField from 'material-ui/TextField';

/* Style */
import {
  textInputBox,
  textActiveInputBox,
  textErrorInputBox,
} from '../../../styles/input.style';
import './inputs.scss';

import { TextInputProps, TextInputState } from './types';

class TextInput extends React.Component<TextInputProps, TextInputState> {
  constructor(props: TextInputProps) {
    super(props);
    this.state = {
      focused: false,
    };
  }

  onChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
    const { value } = event.target;
    this.props.onChange(this.props.id, value);
  };

  handleKeyboardType = (validators?: Array<string>) => {
    if (validators && validators.includes('email')) {
      return 'email';
    }
    return 'text';
  };

  onBlur = () => {
    this.setState({ focused: false });
    this.props.onBlur(this.props.id);
  };

  onFocus = () => {
    this.setState({ focused: true });
  };

  render() {
    const {
      hintText,
      id,
      input,
      inputBoxStyle,
      autoFocus,
      floatingLabelText,
      multiLine,
      name,
      rows,
      showError,
      staticLabelText,
      validators,
      className,
      disabled,
    } = this.props;
    const { focused } = this.state;

    let boxStyle;
    if (focused) {
      boxStyle = { ...textActiveInputBox };
    } else if (showError) {
      boxStyle = { ...textErrorInputBox };
    } else {
      boxStyle = { ...textInputBox };
    }

    // MultiLine inputs should have their height calculated automatically from rows.
    if (multiLine) {
      // Spread operator doesnt do a deep copy; remove height this way.
      const { height, ...style } = boxStyle.style;
      boxStyle.style = style;
    }

    if (inputBoxStyle) {
      boxStyle.style = { ...boxStyle.style, ...inputBoxStyle };
    }

    return (
      <div>
        {staticLabelText && (
          <div className="Input_static-label">{staticLabelText}</div>
        )}
        <TextField
          id={id}
          className={className}
          name={name}
          value={input}
          disabled={disabled || false}
          onBlur={this.onBlur}
          onFocus={this.onFocus}
          onChange={this.onChange}
          type={this.handleKeyboardType(validators)}
          autoFocus={autoFocus}
          floatingLabelText={floatingLabelText}
          hintText={hintText}
          multiLine={multiLine}
          underlineShow={false}
          rows={rows}
          fullWidth
          {...boxStyle}
        />
      </div>
    );
  }
}

export default pure(TextInput);

/* Example use with TextInputValidator:
<TextInputValidator
  id={'firstName'}
  componentType={'TextInput'}
  floatingLabelText="First Name*"
  hintText="Jane"
  validators={['required']}
  showError={showError}
  errorAlign={'bottom'}
  errorEnum={errorEnum}
  errorMessageOverride={errorMessageOverride}
  input={''}
  onChange={this.onChange}
  onBlur={this.onBlur}
  onValidate={this.onValidate}
  inputBoxStyle={{ maxWidth: '100px' }}
/>
*/
